// register the middleware globally
import {hasTwoFactorAuthentication} from "./hasTwoFactorAuthentication";

export const middlewares = {}
export const globalMiddlewares = {
    hasTwoFactorAuthentication
}

